


























import { Component, Prop, Vue } from 'vue-property-decorator';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';

@Component({
  components: {
    ModalWarning,
  },
})
export default class ButtonIcon extends Vue {
  @Prop({ type: String, default: 'Remover' })
  tooltip!: string;

  @Prop({ type: String, default: 'mdi-trash-can-outline' })
  icon!: string;

  @Prop({ type: String, default: 'error' }) color!: string;

  @Prop({ type: Boolean, default: false }) showConfirm!: boolean;

  @Prop({ type: Boolean, default: false }) showConfirmModal!: boolean;

  @Prop({ type: Object, default: () => ({}) }) modalOptions!: any;

  handleClick() {
    if (this.showConfirm) {
      this.$emit('update:showConfirmModal', true);
    } else {
      this.$emit('click');
    }
  }

  confirm() {
    this.$emit('confirm');
  }

  cancel() {
    this.$emit('cancel');
    this.$emit('update:showConfirmModal', false);
  }

  onModalInput(val: boolean) {
    this.$emit('update:showConfirmModal', val);
  }
}
